// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'babel-polyfill'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from '@/assets/js/AxiosPlugin'
import NutUI from '@nutui/nutui'
import '@nutui/nutui/dist/nutui.css'
import Preview from '@/components/webpc/Preview/index.js'

NutUI.install(Vue)
Vue.use(ElementUI)
Vue.use(Preview)
Vue.prototype.$http = axios

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js